import { RefObject, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { TranslationService } from '../../../../../../../../services/translation.service';
import { AnalyticsService } from '../../../../../../../../services/analytics-service';
import type { IJourney } from '../../../../../../../../models/journey.model';
import CalendarDownloads from '../CalendarDownloads';
import DeviceHelper, { DeviceType } from '../../../../../../../../helpers/device.helper';

function Toolbar({ journey, printContentRef }: { journey: IJourney; printContentRef: RefObject<HTMLDivElement | null> }) {
  // === STATE ===
  const [showCalendarArea, setShowCalendarArea] = useState(false);

  // === VARIABLES ===
  const browser = DeviceHelper.getBrowser();
  const isChromeForiOS = browser?.name === 'crios' && browser?.deviceType === DeviceType.iOS;
  const canDownloadCalendar = !isChromeForiOS;
  const canPrint = browser.deviceType === DeviceType.Desktop;

  const handlePrintButtonClick = useReactToPrint({ contentRef: printContentRef });

  return (
    <div className="d-print-none">
      <div className="d-flex flex-wrap">
        {canPrint && (
          <button
            className={`btn btn-tertiary btn-icon-left btn-icon-print ${canDownloadCalendar && !journey.destinationLink ? 'me-3' : ''}`}
            type="button"
            onClick={() => {
              handlePrintButtonClick();
              AnalyticsService.addEvent(AnalyticsService.TravelPlannerCategory, 'Skriv ut', '');
            }}
          >
            {TranslationService.get('travelplanner.printversion')}
          </button>
        )}
        {canDownloadCalendar && !journey.destinationLink && (
          <button
            className="btn btn-tertiary btn-icon-left btn-icon-calendar-plus"
            aria-expanded={showCalendarArea ? 'true' : 'false'}
            type="button"
            onClick={() => {
              setShowCalendarArea(!showCalendarArea);
              AnalyticsService.addEvent(AnalyticsService.TravelPlannerCategory, 'Lägg till i kalender', '');
            }}
          >
            {TranslationService.get('travelplanner.addcalendar')}
          </button>
        )}
      </div>
      {showCalendarArea && <CalendarDownloads journey={journey} />}
    </div>
  );
}

export default Toolbar;
